export default {
    init() {
      document.getElementById('eventflyer__btn')
      .addEventListener('click', function(){
        $('#btn-loader').addClass('loader');        
        window.SejdaJsApi.htmlToPdf({
          filename: 'EventFlyer.pdf',
          pageSize: 'a4',
          //dev
          publishableKey: 'api_public_fa04350d01fa4550a31155bbeafa565a',
          //live
          //publishableKey: 'api_public_23501fb748344b87aa04ef5384ed282b',
          //htmlCode: document.querySelector('html').innerHTML,
          url: window.location.href,
          pageOrientation: 'portrait',
          viewportWidth: 1200,
          hideNotices: true,
          usePrintMedia: true,
          pageMargin: 0,
          pageMarginUnits: 'cm',
          always: function(){     
            $('#btn-loader').removeClass('loader');  
          },
        });
      })           
    },
    finalize() {      
      // JavaScript to be fired on the home page, after the init JS
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/eventflyer.js